import { useDispatch } from "react-redux";
import {
  setExcludeDemoMode,
  setProviders,
  setGameCategories,
  setFillCategoryById,
  setBonusProvider,
  setIdProvidersLiveGame
} from "../../store/gamesSlice";
import { setBanners, setCasinoField } from "../../store/commonSlice";
import { useEffect } from "react";
import { API_CASINO } from "../../api/casino";
import {
  BONUS_PROVIDER_NAME,
  checkUrlBotTg,
  DEBUG,
  ENUM_LCS_NAME,
  TEST_MODE
} from "../../store/enums";
import { testCasinoInfo, testProviders } from "../../store/testConst";
import { useLocalStorage } from "usehooks-ts";
import {
  getParamFromUrl,
  getUrlProviderHover,
  getUrlProviderLogo,
  getUrlProviders,
  LIVE_PROVIDER_NAME
} from "../../utils/utils";
import { setErrorInfo, setMainLoader } from "../../store/siteSlice";
import { useAppSelector } from "../../store/index.ts";

// const MINUTES = 60;
const MINUTES = 0.1;

export default function useFillCasino() {
  const dispatch = useDispatch();
  const lang = useAppSelector((state) => state.common.lang);

  const [startR, setStartR] = useLocalStorage(ENUM_LCS_NAME.startR, "");
  const [pbParams, setPbParams] = useLocalStorage(ENUM_LCS_NAME.pbParams, "");
  const [casinoInfo, setCasinoInfo] = useLocalStorage(ENUM_LCS_NAME.casinoInfo, {});

  const getMinutes = (mn) => mn * 60000;

  const fillCategories = (gameCategories) => {
    dispatch(setGameCategories(gameCategories));
    const categoryById = gameCategories.reduce((acc, item) => {
      const { id, ...rest } = item;
      acc[id] = rest;
      return acc;
    }, {});

    dispatch(setFillCategoryById(categoryById));
  };

  // fillCasinoInfo - заполнение стора инфой полученный от сервера при инициализации
  const fillCasinoInfo = (data) => {
    const gameCategories = data.gameCategories || [];
    const banners = [...(data?.banners || [])];
    const isTgBot = checkUrlBotTg();

    fillCategories(gameCategories);
    dispatch(setExcludeDemoMode(data.excludeFromDemo));
    dispatch(setCasinoField(data));

    let newBanners = banners.sort((l, r) => l.position - r.position);
    // если мы уже в боте убираем баннеры которые ведут на бота
    if (isTgBot) {
      newBanners = newBanners.filter((el) => !el.makeBotLink);
    }
    dispatch(setBanners(newBanners));
  };

  // getStartR - получение start_r
  const getStartR = () => {
    if (startR) return startR;
    const tempStartR = getParamFromUrl("start");
    if (tempStartR) setStartR(tempStartR);

    return tempStartR;
  };

  // getPbParams - получение pb_params
  const getPbParams = () => {
    if (pbParams) return pbParams;

    const queryParams = new URLSearchParams(location.search);
    queryParams.delete("start");
    queryParams.delete("mode");
    queryParams.delete("sessionId");

    const tempBpParams = queryParams.toString();
    const base64EncodedQueryString = btoa(tempBpParams);
    if (tempBpParams) setPbParams(base64EncodedQueryString);
    return tempBpParams;
  };

  const getProviders = () => {
    API_CASINO.list
      .providers()
      .then((e) => {
        const list = e.data.list;
        let bonusProvider = null;
        let idProvidersLiveGame = [];

        const providers = Object.entries(list).map(([id, provider]) => {
          if (BONUS_PROVIDER_NAME === provider.name) bonusProvider = { id, ...provider };
          if (LIVE_PROVIDER_NAME.includes(provider.name)) idProvidersLiveGame.push(id);

          return {
            id: id,
            name: provider.name,
            gameCount: provider.gameCount,
            image: getUrlProviders(provider.name),
            imageHover: getUrlProviderHover(provider.name),
            logo: getUrlProviderLogo(provider.name)
          };
        });
        dispatch(setProviders(providers));
        dispatch(setBonusProvider(bonusProvider));
        dispatch(setIdProvidersLiveGame(idProvidersLiveGame));
      })
      .catch(console.log);
  };

  const getCasinoInfo = () => {
    const start_r = getStartR() || "";
    const pb_params = getPbParams() || "";
    const isSameLang = lang == casinoInfo?.lang;

    if (isSameLang && +casinoInfo?.time + getMinutes(MINUTES) > +new Date()) {
      const favoritesId = JSON.parse(localStorage.getItem(ENUM_LCS_NAME.favoritesId)) || [];
      try {
        fillCasinoInfo(casinoInfo.info, false, favoritesId);
      } catch (e) {
        dispatch(setErrorInfo(true));
      }

      // что бы успел прогрузиться сайт
      dispatch(setMainLoader(false));
    } else {
      API_CASINO.info({ start_r, pb_params, lang })
        .then((e) => {
          if (!e.data) {
            // dispatch(setErrorInfo(true));
            return;
          }
          fillCasinoInfo(e.data, true);

          setCasinoInfo({ time: +new Date(), info: e.data, lang: lang });
          if (DEBUG && e.data.error) console.log("error casino info", e.data?.error);
        })
        .catch((e) => {
          // dispatch(setErrorInfo(true));
          console.error("catch casino info ", e);
        })
        .finally(() => {
          dispatch(setMainLoader(false));
        });
    }
  };

  useEffect(() => {
    if (TEST_MODE) {
      const favoritesId = JSON.parse(localStorage.getItem(ENUM_LCS_NAME.favoritesId)) || [];
      fillCasinoInfo(testCasinoInfo, false, favoritesId);
      dispatch(setMainLoader(false));
      dispatch(setProviders(testProviders));
      return;
    }

    getCasinoInfo();
    getProviders();
  }, [lang]);
}
